import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import { Alert, Button, Form } from "react-bootstrap";
import colors from "../utils/colors";

// import useAuth from "../../hooks/useAuth";

function LoginForm() {
  const navigate = useNavigate();
  const signIn = () => {
    console.log("call sign in api");
  };

  return (
    <Formik
      initialValues={{
        email: "admin@sls.com.au",
        password: "unsafepassword",
        submit: false,
      }}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          //   await signIn(values.email, values.password);

          navigate("/sls");
        } catch (error: any) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Alert className="my-3 text-center" variant="primary">
            <div className="alert-message">
              Use <strong>SLS Admin</strong> account to sign in
            </div>
          </Alert>
          {/* {errors.submit && (
            <Alert className="my-3" variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )} */}

          <Form.Group className="mb-3 text-start">
            <Form.Label>Email</Form.Label>
            <Form.Control
              size="sm"
              type="email"
              name="email"
              placeholder="Enter your email"
              value={values.email}
              isInvalid={Boolean(touched.email && errors.email)}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {!!touched.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Password</Form.Label>
            <Form.Control
              size="sm"
              type="password"
              name="password"
              placeholder="Enter your password"
              value={values.password}
              isInvalid={Boolean(touched.password && errors.password)}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {!!touched.password && (
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            )}
            <small>
              <Link to="/auth/reset-password">Forgot password?</Link>
            </small>
          </Form.Group>

          <div>
            <Form.Check
              type="checkbox"
              id="rememberMe"
              label="Remember me next time"
              defaultChecked
            />
          </div>

          <div className="text-center mt-3">
            <Button
              type="submit"
              variant="primary"
              size="sm"
              disabled={isSubmitting}
              className="login-btn"
              style={{
                background: colors.SLSprimary,
                border: "none",
                width: "100px",
                height: "35px",
              }}
            >
              Sign in
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default LoginForm;
